export const links = [
  {
    to: "/",
    title: "HOME",
  },
  {
    to: "/makeup",
    title: "MAKEUP",
  },
  {
    to: "/haircare",
    title: "BONZER",
  },
  {
    to: "/skincare",
    title: "EYEBROW",
  },
  {
    to: "/sanetising-care",
    title: "EYELINER",
  },
  {
    to: "/collectios",
    title: "EYESHADOW",
  },
  {
    to: "/rewards",
    title: "FOUNDATION",
  },
  {
    to: "/myglamm-studio",
    title: "LIPLINER",
  },
  {
    to: "/offers",
    title: "OFFERS",
  },
];
export const subCat = [
  {
    to: "/skincare",
    img: "images/Skin.png",
    title: "Skin",
  },
  {
    to: "/makeup",
    img: "images/Lips.png",
    title: "Lips",
  },
  {
    to: "/haircare",
    img: "images/hair.jpg",
    title: "Hair",
  },
  {
    to: "/skincare",
    img: "images/Eyes.png",
    title: "Eyes",
  },
  {
    to: "/skincare",
    img: "images/Face.png",
    title: "Face",
  },
  {
    to: "/skincare",
    img: "images/Nails.png",
    title: "Nails",
  },
  {
    to: "/sanetising-care",
    img: "images/SC.png",
    title: "SANITIZING CARE",
  },
  {
    to: "/skincare",
    img: "images/Bath.png",
    title: "Bath & Body",
  },
];
